import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "lab-links" }
const _hoisted_2 = { class: "lab-links__subscribe" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "lab-links__counter"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "lab-links__counter"
}
const _hoisted_7 = {
  key: 0,
  class: "lab-links__subscribe"
}
const _hoisted_8 = ["href"]

import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { ElTooltip } from 'element-plus';
import IconPlay from '@/components/icons/PlayBtn.vue';
import { LabData } from '@/types/LabData';
import { catchErrorShow, getStorageItem, pluralNoun, setStorageItem, isMobile } from '@/utils';
import { loginUser } from '@/services/userActions';
import services from '@/router/Laboratories/services';
import { names } from '@/constants/routes';
import ShopCart from '@/components/icons/ShopCart.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Links',
  props: {
    product: {}
  },
  emits: ["showMobileModal"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const store = useStore();
const router = useRouter();
const isMobileConst = isMobile();

const emit = __emit;

const props = __props;

const canLaunch = computed(() => props.product?.active_for_user);
const buttonLinks = computed(() => props.product.links.slice().sort((a, b) => a.order - b.order));
const isUser = computed(() => store.getters.isAuthed);
const isOrganization = computed(() => store.getters.isOrgOwner || store.getters.isOrgModerator);
const orgId = computed(() => store.getters.organizationId);

const didUserHaveLicenses = computed(
  () => props.product.self_license_expiration_date
);

const showDemoBtn = computed(() => props.product.demo_mode && !didUserHaveLicenses.value);

const launchLink = computed(() => {
  if (
    !props.product?.uuid
    || (props.product.demo_mode && !props.product.demo_counter)
  ) {
    return undefined;
  }

  return props.product.demo_mode
    ? `/api/product/launch-as-demo/${props.product.uuid}?is_mobile=${Number(isMobileConst)}`
    : `/api/product/launch/${props.product.uuid}?is_mobile=${Number(isMobileConst)}`;
});

const launchApp = () => {
  if (isMobileConst) {
    handleMobileLaunch();
  }
};

const launchDemoApp = () => {
  if (!isUser.value) {
    return loginUser();
  }

  if (!hasDemoLaunches.value) {
    return;
  }

  if (isMobileConst) {
    handleMobileLaunch();
  } else {
    decreaseDemoCounting();
  }

  store.commit('Common/ADD_RECENT', props.product.id);
};

const decreaseDemoCounting = () => {
  setTimeout(() => {
    store.commit('Common/SET_DEMO_COUNTER', demoCounter.value - 1);
  }, 0);
};

const pushMobileStatistics = () => {
  if (props.product.uuid) {
    try {
      services.sendAccountingAppUrl(props.product.uuid, isMobileConst, props.product.demo_mode);
    } catch (err) {
      catchErrorShow(err, t);
    }
  }
};

const handleMobileLaunch = () => {
  emit('showMobileModal');
  pushMobileStatistics();
};

const demoCounter = computed(() => store.getters['Common/demoCounter']);
const hasDemoLaunches = computed(() => demoCounter.value && Number(demoCounter.value) > 0);
const isDemoDisabled = computed(
  () => !isUser.value
      || !hasDemoLaunches.value
      || !launchLink.value
);

const demoCounterTooltipText = computed(() => {
  if (!hasDemoLaunches.value) {
    return t('tooltipLaunchHasLimit');
  }
  return t(
    'youHaveNLaunchesLeft',
    {
      nn: demoCounter.value || 0,
    },
    pluralNoun(demoCounter.value || 0),
  );
});

const orgSubscriptionLink = `/admin/organization/${orgId.value}/orders`;

const handleSubscribeClick = () => {
  if (isOrganization.value) {
    return;
  }

  // Get from local storage and covert into Set for unique values
  const basket = new Set(getStorageItem<number[]>('basket') || []);
  if (props.product?.offer?.id) {
    // Add offer id of product to select them in shop
    basket.add(props.product?.offer?.id);
  }
  // Update basket
  setStorageItem('basket', Array.from(basket.values()));

  // Go into shop
  router.push({ name: names.shop });
};

watch(() => props.product.demo_counter, (val) => {
  store.commit('Common/SET_DEMO_COUNTER', val);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (canLaunch.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "lab-links__btn-play ui-btn --style-1",
            href: _unref(isMobileConst) ? undefined : launchLink.value,
            target: "_blank",
            onClick: launchApp
          }, [
            _createTextVNode(_toDisplayString(_unref(t)("labs.launch")) + " ", 1),
            _createVNode(IconPlay),
            (_unref(isMobileConst))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " ? "))
              : _createCommentVNode("", true)
          ], 8, _hoisted_3))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(isOrganization.value ? 'a' : 'button'), {
              class: "lab-links__btn-play ui-btn --style-1",
              href: isOrganization.value ? orgSubscriptionLink : undefined,
              onClick: handleSubscribeClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("labs.subscribe")) + " ", 1),
                _createVNode(ShopCart)
              ]),
              _: 1
            }, 8, ["href"])),
            (showDemoBtn.value)
              ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                  key: 0,
                  class: "box-item",
                  effect: "light",
                  placement: "top",
                  content: isUser.value ? demoCounterTooltipText.value : _unref(t)('tooltipLogIn'),
                  disabled: _unref(isMobileConst) && hasDemoLaunches.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      class: _normalizeClass(["lab-links__btn-play ui-btn --style-1", { 'mobile': _unref(isMobileConst), 'disabled': isDemoDisabled.value }]),
                      href: isDemoDisabled.value || _unref(isMobileConst) ? undefined : launchLink.value,
                      target: "_blank",
                      onClick: launchDemoApp
                    }, [
                      _createTextVNode(_toDisplayString(_unref(t)("labs.demo")) + " ", 1),
                      _createVNode(IconPlay),
                      (!isDemoDisabled.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(isMobileConst) ? '?' : demoCounter.value), 1))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_5)
                  ]),
                  _: 1
                }, 8, ["content", "disabled"]))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    (buttonLinks.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttonLinks.value, (link) => {
            return (_openBlock(), _createElementBlock("a", {
              key: `link-${link.id}`,
              class: "lab-links__btn-link ui-btn --style-2",
              href: link.locales[0].url
            }, _toDisplayString(link.locales[0].caption), 9, _hoisted_8))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})